import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { TranslationFile } from 'i18n'

function PaymentVerification() {
	const { t } = useTranslation([TranslationFile.PaymentVerification])
	const [query] = useSearchParams()
	const transactionId = query.get('transactionId')

	return (
		<div className="h-100 login-bg">
			<div className="h-100 inner d-flex justify-content-center align-items-center w-100">
				<div className="login-container m-2 d-flex flex-column justify-content-between align-items-center">
					<div className="authButton GermanyOtp"></div>
					<div className="p-4 content">
						<div className="mobileId">
							<div className="mx-auto text-center">
								<h3>{t('title')}</h3>
								<p>{t('description')}</p>
								<p>
									{transactionId
										? `${t(
												'transaction',
										  )}: ${transactionId}`
										: null}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default PaymentVerification
